import React from "react";
import { HelpCircle, Phone } from "lucide-react";
import { faqs, site } from "../mock/mock";
import { Eyebrow } from "./SectionHeading";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export default function Faq() {
  return (
    <section id="faq" className="py-24 lg:py-32" style={{ background: "var(--sand)" }}>
      <div className="mx-auto grid max-w-[1280px] gap-14 px-5 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20 lg:px-6">
        <div data-reveal="">
          <Eyebrow>General Questions</Eyebrow>
          <h2
            className="font-display mt-5 text-[2.1rem] leading-[1.1] tracking-tight sm:text-[2.7rem]"
            style={{ color: "var(--teal-900)", fontWeight: 400 }}
          >
            Frequently asked questions
          </h2>
          <p className="mt-6 text-[0.98rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
            Everything parents usually ask us before the campus visit. Still unsure about something?
            Our admissions team is happy to talk it through.
          </p>

          <a
            href={`tel:${site.hotlines[0].replace(/\s/g, "")}`}
            className="mt-9 inline-flex items-center gap-3 rounded-2xl bg-white px-6 py-5"
            style={{ border: "1px solid rgba(11,59,54,.1)", transition: "box-shadow .3s ease" }}
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 22px 44px -30px rgba(8,46,41,.5)")}
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
          >
            <span
              className="grid h-11 w-11 place-items-center rounded-xl"
              style={{ background: "var(--teal-100)", color: "var(--teal-700)" }}
            >
              <Phone size={18} strokeWidth={1.7} />
            </span>
            <span>
              <span className="block text-[0.7rem] tracking-[0.16em] uppercase" style={{ color: "var(--gold)" }}>
                Admissions helpline
              </span>
              <span className="font-display block text-[1.1rem]" style={{ color: "var(--teal-900)" }}>
                {site.hotlines[0]}
              </span>
              <span className="font-display block text-[1.1rem]" style={{ color: "var(--teal-900)" }}>
                {site.hotlines[1]}
              </span>
            </span>
          </a>
        </div>

        <div data-reveal="" style={{ transitionDelay: "120ms" }}>
          <Accordion type="single" collapsible defaultValue="item-0" className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="overflow-hidden rounded-2xl bg-white px-6"
                style={{ border: "1px solid rgba(11,59,54,.09)" }}
              >
                <AccordionTrigger className="py-6 text-left hover:no-underline">
                  <span className="flex items-start gap-4 pr-3">
                    <HelpCircle size={18} strokeWidth={1.7} style={{ color: "var(--gold)", marginTop: 2 }} />
                    <span
                      className="font-display text-[1.08rem] leading-snug"
                      style={{ color: "var(--teal-900)" }}
                    >
                      {f.q}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-7 pl-[34px] pr-3 text-[0.92rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
